/**
 * @module Global
 */
import $ from 'jquery'
import store from './store'

/**
 * Settings for the appconfig endpoint
 * If app is running on `localhost`
 * `environment` and `origin` are used in the query params
 * If app is running on a live server then
 * `environment` if set based off the url it's hosted at
 * and `origin` is passed as-is
 */

const url = 'https://appconfig.api.unoapp.io/api/v1/appconfig'
const headers = {
  'app-id': '44f51ffe7ee9f76613edb16e3f40d0c7be198ecc',
  'app-secret': 'f91ddc6228be355c75d9f1bc63e66d9c78e67f3a'
}
const hostname = window.location.hostname
const localhost = hostname === 'localhost'
const environment = (function () {
  if (localhost) return 'staging'
  if (hostname.includes('dev')) return 'development'
  if (hostname.includes('beta')) return 'staging'
  if (hostname.includes('staging')) return 'staging'
  return 'production'
}())
const origin = 'williamscafe.beta.unoapp.io'

export const appconfig = {
  url,
  headers,
  hostname,
  localhost,
  environment,
  origin
}

/**
 * Ajax wrapper for making backend calls.
 * @function
 * @param {object} options - Options for the ajax call being made.
 * @param {string} api - The api to call
 * @returns {undefined}
 */
export const $ajax = async function (options, api = 'ecomm') {
  if (!options.url.startsWith('http')) {
    if (api === 'ecomm') {
      options.url = store.getters.apis[api].url + '/api' + options.url
    } else if (api === 'ecomm-oma') {
      options.url = store.getters.apis[api].url + options.url
      api = 'ecomm'
    } else if (api === 'authorization') {
      options.url = store.getters.apis.ecomm.url + '/api' + options.url
    } else {
      options.url = store.getters.apis[api].url + options.url
    }
  }

  const apis = store.getters.apis
  const headers = {
    'app-id': apis[api].headers['app-id'],
    'app-secret': apis[api].headers['app-secret'],
    'auth-token': apis[api].headers['auth-token']
  }
  if (headers['app-id'] === 'ecomm') {
    headers['app-id'] = store.getters.appId
  }
  if (headers['app-secret'] === 'ecomm') {
    headers['app-secret'] = store.getters.appSecret
  }
  if (headers['auth-token'] === 'ecomm') {
    headers['auth-token'] = store.getters.userToken
  }

  if (api === 'approvals') {
    headers['approvals-app-id'] = apis.approvals.headers['approvals-app-id']
    headers['approvals-app-secret'] = apis.approvals.headers['approvals-app-secret']
  }

  if (api === 'authorization') {
    headers['api-token'] = apis.authorization.headers['api_token']
  }

  if (api === 'notifications_oma' || api === 'notifications_users') {
    headers['app-token'] = apis[api].headers['app-token']
  }

  options.beforeSend = undefined
  options.headers = headers

  if (options.processData !== false) {
    const method = options.method.toLowerCase()
    if (method === 'post' || method === 'put') {
      if (!options.contentType) {
        options.contentType = 'application/json'
      }
      if (options.contentType === 'application/json') {
        options.data = JSON.stringify(options.data)
      }
    }
  }

  return $.ajax(options)
}

export default {
  $ajax
}
